import { render, staticRenderFns } from "./ImportPreview.vue?vue&type=template&id=96f06672&"
import script from "./ImportPreview.vue?vue&type=script&lang=js&"
export * from "./ImportPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports